<template>
  <div>
    <post-feed class="post-feed-tag flex-grow" :posts="posts" :processing="processing">
      <!-- <template v-slot:post-cell="{ post, cellOffsetStyle }">
        <div class="relative" :style="cellOffsetStyle">{{post.title}}</div>
      </template> -->
    </post-feed>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { db } from '@/lib/firebase'
import FeedSubscription from '../mixins/feed-subscription'
import PostFeed from './components/PostFeed.vue'
import { generateShortTitle, clearShortTitlesCache, registerShortTitle } from '@/lib/short-title.js'
import { comparePostsByDisplayOrder } from '@/lib/post-order.js'

export default {
  name: 'PostFeedByTag',
  mixins: [FeedSubscription],
  components: { PostFeed },

  data: () => ({
    feed: {},
    includeDrafts: false,
    orderBy: { field: 'date', direction: 'desc' }
  }),
  computed: {
    ...mapState(['curTag']),
    posts () {
      let posts = []
      if (this.tagId) {
        posts = Object.values(this.feed).sort(comparePostsByDisplayOrder)
      } else {
        posts = Object.values(this.feed)
          .filter(post => !(post.tagIds || []).length)
          .sort(comparePostsByDisplayOrder)
      }

      // Clear cache to start fresh
      clearShortTitlesCache()

      // Generate short titles for each post individually
      const postsWithShortTitles = posts.map(post => {
        if (!post || !post.title) {
          return { ...post, shortTitle: '' }
        }

        // If shortTitle already exists, add it to cache and keep it
        if (post.shortTitle) {
          registerShortTitle(post.shortTitle)
          return post
        }

        // Generate new short title
        const shortTitle = generateShortTitle(post.title)
        return { ...post, shortTitle }
      })

      // Add back button with a simple short title
      const backButton = { title: '←', type: 'back-button', shortTitle: '←' }
      registerShortTitle('←') // Register it to avoid conflicts

      return [backButton, ...postsWithShortTitles]
    },
    tagId () {
      return (this.$route.params.id || '').trim()
    },
    tagTitle () {
      return (this.curTag || {}).title || ''
    }
  },
  created () {
    this.setTag()
  },
  watch: {
    processing (val) {
      if (val) return
      setTimeout(() => {
        if (!this.$refs['logo-box']) return
        const top = this.$refs['logo-box'].getBoundingClientRect().bottom
        window.scrollTo({ top, behavior: 'smooth' })
      }, 500)
    },
    $route () {
      this.setTag()
    }
  },

  methods: {
    ...mapActions(['updateCurTag']),
    async setTag () {
      if ((this.curTag || {}).id === this.tagId) return
      if (!this.tagId) {
        if (this.curTag) {
          this.updateCurTag(null)
        }
        return
      }
      try {
        const tagSnap = await db.collection('tags').doc(this.tagId).get()
        if (tagSnap.exists) {
          this.updateCurTag({ ...tagSnap.data(), id: tagSnap.id })
        }
      } catch (e) {
        this.updateCurTag(null)
        console.error(e)
      }
    }
  }

}
</script>

<style lang='scss'></style>
